<div class="bacground"
     [ngStyle]="{'background-color': backgroundColor()}">

    <div class="label">
        <p>{{labelId() | translate | uppercase}}</p>
    </div>

</div>